import Cookies from "./components/cookies";
import Navigation from "./components/navigation";
import navigationDropdowns from "./components/navigationDropdowns";
import HomeHero from "./components/homeHero";
import Facts from "./components/facts";
import Testimonials from "./components/testimonials";
import Partners from "./components/partners";
import ContactForm from "./components/contactForm";
import ImpressionSlider from "./components/impressionSlider";
import CoursesFilter from "./components/coursesFilter";
import RegistrationForm from "./components/registrationForm";
import AboutVideo from "./components/aboutVideo";
import FaqBackButton from "./components/faqBackButton";
import AllowYouTubeVideos from "./components/allowYouTubeVideos";

// Init Cookies Banner
// const $cookieModal = document.getElementById("cookie-modal");
// if ($cookieModal) new Cookies();

// Main Navigation
const $navigation = document.getElementById("header");
if ($navigation) new Navigation($navigation);

// Navigation Dropdown Menus
const $dropdownMenus = document.querySelectorAll("#header .nav__menu");
if ($dropdownMenus) new navigationDropdowns($dropdownMenus);

// Home Hero
const $homeHero = document.querySelector("body.home-page .hero");
if ($homeHero) new HomeHero($homeHero);

// Facts
const $facts = document.querySelectorAll(".facts");
$facts.forEach((fact) => {
  new Facts(fact);
});

// Testimonials
const $testimonials = document.querySelectorAll(".testimonials");
$testimonials.forEach((testimonial) => {
  new Testimonials(testimonial);
});

// Partners
const $partners = document.querySelector(".partner");
if ($partners) new Partners($partners);

// Contact form
const $contactForm = document.getElementById("contactForm");
if ($contactForm) {
  new ContactForm($contactForm);
}

// Impression Slider
const $impressionSlider = document.querySelectorAll(".impression-slider");
$impressionSlider.forEach((slider) => {
  new ImpressionSlider(slider);
});

// Courses Filter
const $coursesFilter = document.getElementById("coursesFilter");
if ($coursesFilter) {
  new CoursesFilter($coursesFilter);
}

// Registration Form
const $registrationForm = document.getElementById("registrationForm");
if ($registrationForm) {
  new RegistrationForm($registrationForm);
}

// About Video
const $aboutVideo = document.querySelector(".about-header__video");
if ($aboutVideo) {
  new AboutVideo($aboutVideo);
}

// FQA Back Button
const $faqBackButton = document.querySelector(
  "body.faqquestion-page .page-header__back"
);
if ($faqBackButton) {
  new FaqBackButton($faqBackButton);
}

// Consent to YouTube videos via one click
// const $allowYouTubeVideos = document.getElementById("allowYouTube");
// if ($allowYouTubeVideos) {
//   new AllowYouTubeVideos($allowYouTubeVideos);
// }


// Wait for DOM to load
document.addEventListener("DOMContentLoaded", () => {
  console.log(window.CookieConsent);
  window.CookieConsent.run({
    onFirstConsent: ({cookie}) => {
        // do something
        console.log("First consent done");
    }
  });
});

console.log("wtf?!?!?!");